import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import { ConfirmationModal } from "../UI/ConfirmationModal/ConfirmationModal";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const initialState = {
	orgaosComPastaSegura: [],
	pastasSegurasAtivas: [],
	novaPastaSegura: "",
	carregando: true,
	exibeModalConfirmacao: false,
};

export const PastaSeguraDisponivelManutencao =

// router
withRouter(
// redux
connect(
	(null),
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = initialState;

			this.handleInputChange = this.handleInputChange.bind(this);
			this.confirmaAlteracao = this.confirmaAlteracao.bind(this);
			this.alterarPastaSegura = this.alterarPastaSegura.bind(this);
			this.fechaModal = this.fechaModal.bind(this);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			this.carregarDados();
		}

		carregarDados(){
			this.props.mostraAguardando();
			Promise.all([
				api.get('/api/pasta-segura-disponivel/orgaos-com-pasta-segura'),
				api.get('/api/pasta-segura-disponivel/todas-ativas'),
			])
				.then(([orgaosResponse, ativasResponse]) => {
					this.setState({
						orgaosComPastaSegura: orgaosResponse.data || [],
						pastasSegurasAtivas: ativasResponse.data || [],
						carregando: false,
					});
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível carregar os dados de Manutenção de Pasta Segura.", erro);
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					this.setState({ carregando: false });
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		getOrgaoAtual(){
			const { idOrgao } = this.props.match.params;
			const { orgaosComPastaSegura } = this.state;
			return orgaosComPastaSegura.find(o => String(o.idOrgao) === String(idOrgao));
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />

					<div style={{margin: "10px"}}>
						<h1>Manutenção de Pasta Segura</h1>
					</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		renderForm() {
			const { carregando, novaPastaSegura, orgaosComPastaSegura } = this.state;
			const orgaoAtual = this.getOrgaoAtual();

			if (carregando) {
				return null;
			}

			return(
				<div className="container-fluid">
					<ConfirmationModal
						isOpen={this.state.exibeModalConfirmacao}
						onClose={this.fechaModal}
						onConfirm={this.alterarPastaSegura}
						message={this.getMensagemConfirmacao()}
					/>

					<div className="br-form">
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="nomeOrgao">Órgão:</label>
										<input type="text" name="nomeOrgao" value={orgaoAtual?.nomeOrgao || ""} readOnly />
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="pastaSeguraAtual">Pasta Segura Atual:</label>
										<input type="text" name="pastaSeguraAtual" value={orgaoAtual?.nomePastaSegura || ""} readOnly />
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="novaPastaSegura">Nova Pasta Segura:</label>
										<SelectSearch
											id="novaPastaSegura"
											name="novaPastaSegura"
											options={this.getOpcoesPastaSegura()}
											onChange={this.handleInputChange}
											value={novaPastaSegura}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={this.confirmaAlteracao} disabled={!novaPastaSegura}>Confirmar</button>
								<ButtonBack />
							</div>
						</div>

						{orgaosComPastaSegura.length > 0 &&
							<div className="mt-4">
								<h2>Órgãos com Pasta Segura Cadastrada</h2>
								<div className="br-table">
									<div className="table">
										<table>
											<thead>
												<tr>
													<th scope="col">Órgão</th>
													<th scope="col">Pasta Segura</th>
												</tr>
											</thead>
											<tbody>
												{orgaosComPastaSegura.map((orgao, index) =>
													<tr key={index}>
														<td>{orgao.nomeOrgao}</td>
														<td>{orgao.nomePastaSegura}</td>
													</tr>
												)}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						}
					</div>
				</div>
			);
		}

		getOpcoesPastaSegura(){
			const { pastasSegurasAtivas } = this.state;
			return pastasSegurasAtivas.map(nome => ({ value: nome, label: nome }));
		}

		getOrgaoDaPastaSelecionada(){
			const { novaPastaSegura, orgaosComPastaSegura } = this.state;
			const { idOrgao } = this.props.match.params;
			return orgaosComPastaSegura.find(o => o.nomePastaSegura === novaPastaSegura && String(o.idOrgao) !== String(idOrgao));
		}

		getMensagemConfirmacao(){
			const orgaoAtual = this.getOrgaoAtual();
			const orgaoDaPastaSelecionada = this.getOrgaoDaPastaSelecionada();

			if (orgaoDaPastaSelecionada) {
				return `Deseja realmente trocar a pasta segura? A pasta "${this.state.novaPastaSegura}" está vinculada ao órgão "${orgaoDaPastaSelecionada.nomeOrgao}", que passará a usar a pasta segura atual deste órgão ("${orgaoAtual?.nomePastaSegura || ''}").`;
			}

			return "Deseja realmente alterar a pasta segura deste órgão?";
		}

		handleInputChange(evento){
			const target = evento.target;
			this.setState({ [target.name]: target.value });
		}

		confirmaAlteracao(){
			this.setState({ exibeModalConfirmacao: true });
		}

		fechaModal(){
			this.setState({ exibeModalConfirmacao: false });
		}

		alterarPastaSegura(){
			const { idOrgao } = this.props.match.params;
			const { novaPastaSegura } = this.state;

			this.fechaModal();
			this.props.mostraAguardando();
			api.put(`/api/orgao/${idOrgao}/pasta-segura/troca`, { nomePastaSegura: novaPastaSegura })
				.then(() => {
					this.props.exibeMensagemSucesso("Pasta segura do órgão alterada com sucesso.");
					this.setState({ novaPastaSegura: "" }, () => this.carregarDados());
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível alterar a pasta segura do órgão.", erro);
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}
	}

) // redux
); // router
